// extracted by mini-css-extract-plugin
export default {"signup-container":"login_signup-container__33d0n"};